var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_862_5311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_862_5311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54986 14.6694L17.7705 6.44873C18.0364 6.18278 18.3517 6.0498 18.7162 6.0498C19.0807 6.0498 19.3959 6.18278 19.6618 6.44873C19.9278 6.71468 20.0607 7.0299 20.0607 7.3944C20.0607 7.75889 19.9278 8.0741 19.6618 8.34005L10.4901 17.5118C10.2241 17.7777 9.91073 17.9107 9.54986 17.9107C9.18899 17.9107 8.87558 17.7777 8.60963 17.5118L4.33788 13.2401C4.07195 12.9741 3.94079 12.6589 3.94441 12.2944C3.94803 11.9299 4.08281 11.6147 4.34876 11.3487C4.61471 11.0828 4.92993 10.9498 5.29443 10.9498C5.65892 10.9498 5.97413 11.0828 6.24008 11.3487L9.54986 14.6694Z",
    fill: "#FF3B3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0c000db9682bd94243855c57855776f0.svg";
export { ForwardRef as ReactComponent };